'use client';

import { useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';
import { Suspense } from 'react';
import { FaGoogle, FaMicrosoft } from 'react-icons/fa6';

import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

const ERROR_COPY: Record<string, string> = {
  OAuthAccountNotLinked:
    'That email is already linked to a different sign-in method. Try the other provider.',
  AccessDenied: 'Access denied. Please try again or contact your admin.',
  Configuration:
    "Sign-in isn't configured correctly. Please contact support.",
  Verification: 'The sign-in link is invalid or has expired.',
};

function SignInContent() {
  const params = useSearchParams();
  const callbackUrl = params.get('callbackUrl') || '/matches';
  const errorCode = params.get('error');
  const errorMessage = errorCode
    ? ERROR_COPY[errorCode] || "Something went wrong signing in. Please try again."
    : null;

  return (
    <>
      <div className="space-y-1">
        <h1 className="text-card-foreground text-xl font-semibold">
          Welcome to Zeno
        </h1>
        <p className="text-xs">
          Sign in to find your best conference connections
        </p>
      </div>

      {errorMessage && (
        <div
          role="alert"
          className="border-destructive/30 bg-destructive/10 text-destructive mt-4 rounded-md border p-3 text-xs"
        >
          {errorMessage}
        </div>
      )}

      <div className="mt-6 space-y-3">
        <Button
          variant="muted"
          onClick={() => signIn('google', { callbackUrl })}
          className="text-muted-foreground flex h-10 w-full items-center justify-center gap-3 text-base"
        >
          <FaGoogle className="size-4.5" />
          Continue with Google
        </Button>

        <Separator className="bg-input" />

        <Button
          variant="muted"
          onClick={() => signIn('microsoft-entra-id', { callbackUrl })}
          className="text-muted-foreground flex h-10 w-full items-center justify-center gap-3 text-base"
        >
          <FaMicrosoft className="size-4.5" />
          Continue with Outlook
        </Button>
      </div>
    </>
  );
}

export default function SignInPage() {
  return (
    <Suspense>
      <SignInContent />
    </Suspense>
  );
}
